import styled from '@emotion/styled';
import { colors, Stack, SideNavItem } from '@ui-components/neo.tax';

export const IconsContainerStack = styled(Stack)<{ $active: boolean }>(
  {
    padding: '0 0.5rem',
    borderRadius: 8,
    borderColor: colors.gray[300],
    borderWidth: 1,
    width: 'fit-content',
    alignSelf: 'end',
  },
  ({ $active }) =>
    $active && {
      borderRadius: '0px 0px 6px 6px',
      backgroundColor: colors.gray[200],
    },
);

export const StyledSideNavItem = styled(SideNavItem)<{ active: boolean }>(
  {},
  ({ active }) =>
    active && {
      "div[role='button']": {
        borderBottomRightRadius: 0,
      },
    },
);
